import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API, ENVIRONMENT } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { LoggerService } from '../../ui/logger/logger.service';
import { BehaviorSubject, Subject, catchError, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { AppModule } from 'src/app/app.module';
import { ServiceModule } from 'src/app/_services/service.module';

@Injectable({
  providedIn: ServiceModule
})
export class FeedbackService {

  subjectFeedback = new Subject<{ success: boolean, command: 'open' | 'close' }>();
  // feedbackSearviceStreamer = new BehaviorSubject<{action:string, data:any}>({action:'', data:{}});

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private authService: AuthService,
  ) { }

  private _questions: ObjectLiteral[] = [];

  get questions(): ObjectLiteral[] {
    return this._questions
  }

  set questions(questions: ObjectLiteral[]) {
    this._questions = questions;
  }

  async getFeedbackQuestions() {
    this.logger.debug('FeedbackService.getFeedbackQuestions()', arguments);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.FEEDBACK}/`;
    let body = {
      action: 'GET_FEEDBACK_QUESTIONS'
    }
    let response = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    // await this.http.post(encodeURI(url), body).toPromise().catch(e => e)

    if (response["success"]) {
      this.setFeedbackQuestions(response["data"])
    }
  }

  async upsertFeedbackAnswers(answers: ObjectLiteral,retryCount?: number) {
    this.logger.debug('FeedbackService.upsertFeedbackAnswer()', answers);
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.UPSERT_FEEDBACK}/`;
    let body = {
      action: 'UPSERT_FEEDBACK_ANSWERS',
      answers: answers
    }
    let headers = {
      "Hostname": this.authService.getHostName(),
      "Xsrf": this.authService.token
    }

    let response = await this.http.post(encodeURI(url), body, {
      headers: new HttpHeaders({
        'Hostname': this.authService.getHostName(),
        'Xsrf': this.authService.token ?? "abc"
      })
    }).pipe(
      catchError(err => {
        return of({ success: false })
      })
    ).toPromise()
    if (response["success"]) {
      this.logger.debug('Succeeded to upsert feedback');
    } else {
      if (retryCount == maxCalloutRetry) throw response;
    if (response["code"] == 403) {
      try {
        await this.authService.refreshToken();
        this.logger.debug('Feedback service : upsertFeedbackAnswers() : Token refresh :: Success');
        return await this.upsertFeedbackAnswers(answers,++retryCount);

      } catch (e) {
        this.logger.debug('Feedback service : upsertFeedbackAnswers() : Exception thrown :: ', e.message);
        throw e;
      }
    } else throw response;
  }

  }


  setFeedbackQuestions(questions: ObjectLiteral) {
    this.logger.debug("FeedbackService.setFeedbackQuestions()", questions);
    this.questions = questions.questionDetails;
  }

}
const maxCalloutRetry = 2